import type { ReactElement, SelectHTMLAttributes } from 'react';

interface SelectOption {
    value: string;
    label: string;
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
    label?: string;
    error?: string;
    options: SelectOption[];
    placeholder?: string;
}

export function Select({
    label,
    error,
    options,
    placeholder,
    className = '',
    ...rest
}: SelectProps): ReactElement {
    const baseClass =
        'w-full rounded border border-gray-300 bg-white px-3 py-2 text-sm focus:border-gray-900 focus:outline-none disabled:bg-gray-100';
    const errorClass = error ? ' border-red-500' : '';

    return (
        <label className="block">
            {label && <span className="mb-1 block text-sm text-gray-700">{label}</span>}
            <select className={`${baseClass}${errorClass} ${className}`} {...rest}>
                {placeholder && <option value="">{placeholder}</option>}
                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
            {error && <span className="mt-1 block text-xs text-red-600">{error}</span>}
        </label>
    );
}
